/**
 * Contact Page
 * Contact Us page combining all sections
 */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import ContactHero from '../components/ContactHero';
import ContactInfo from '../components/ContactInfo';
import ContactForm from '../components/ContactForm';
import FAQSection from '../components/FAQSection';

/**
 * Contact Page Component
 * @returns {JSX.Element} Contact page with all sections
 */
const ContactPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'auto' });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <div className="contact-page">
      <ContactHero />
      <ContactInfo />

      {/* FAQ + Contact Form — two-column on desktop, stacked on mobile */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-6 md:px-8 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-8 items-start">
            {/* Left — FAQ */}
            <div id="support" className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8">
              <FAQSection />
            </div>
            {/* Right — Contact Form */}
            <div id="send-message" className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
